<template>
    <div data-test-view="reviews-progress">
        <l-card-content>
            <l-headline
                :title="$t(`reviews.list.titleAdminEmployee`)"
                :tabs="[
                    {
                        show: true,
                        label: $t(`reviews.list.subtitleAdminEmployee`),
                        popover: $t(`reviews.list.helpAdminEmployee`),
                        tabClass: 'descriptive',
                    },
                ]"
            />

            <div class="row">
                <div class="col-md-6">
                    <l-multi-filter :filter-types="userFilterOptions" @update="applyUserFilters" />
                </div>
                <div class="col-md-3">
                    <l-select
                        v-model="stateFilter"
                        :options="stateFilterOptions"
                        @change="applyStateFilters"
                    />
                </div>
            </div>

            <l-space :size="2" />

            <l-infinite-scroll
                :list="participantProgress"
                :on-list-bottom="getMoreReviewsByEmployee"
                no-data-show
                :no-data-text="$t(`reviews.list.labelNotReviewed`)"
                attach-to-window-scroll
                :can-load-more="!!canLoadMoreReviews"
            >
                <template #item="{ item: employee }">
                    <l-reviews-progress-list-item :employee="employee" />
                </template>
            </l-infinite-scroll>
        </l-card-content>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LCardContent from "@/components/LCardContent";
import LHeadline from "@/components/LHeadline";
import LInfiniteScroll from "@/components/LInfiniteScroll";
import LMultiFilter from "@/components/LMultiFilter";
import LSpace from "@/components/LSpace";
import LSelect from "@/components/LSelect";
import LReviewsProgressListItem from "@/components/LReviewsProgressListItem";

export default {
    components: {
        LCardContent,
        LHeadline,
        LInfiniteScroll,
        LMultiFilter,
        LSpace,
        LSelect,
        LReviewsProgressListItem,
    },
    data() {
        return {
            userFilter: {},
            stateFilter: "all",
            offset: 0,
        };
    },
    computed: {
        ...mapGetters({
            participantProgress: "reviews/assessments/participantProgress",
        }),
        userFilterOptions() {
            return [
                {
                    value: "localTeams",
                    key: "localTeamFilter",
                    text: this.$t("multiFilter.selectLocalTeams"),
                },
                {
                    value: "users",
                    key: "userFilter",
                    text: this.$t("multiFilter.selectUsers"),
                },
                {
                    value: "managers",
                    key: "managerFilter",
                    text: this.$t("multiFilter.selectManagers"),
                },
                {
                    value: "locations",
                    key: "locationFilter",
                    text: this.$t("multiFilter.selectLocations"),
                },
            ];
        },
        stateFilterOptions() {
            return [
                {
                    value: "all",
                    text: this.$t("reviews.list.stateFilterAll"),
                },
                {
                    value: "reviewed",
                    text: this.$t("reviews.list.stateFilterReviewed"),
                },
                {
                    value: "notReviewed",
                    text: this.$t("reviews.list.stateFilterNotReviewed"),
                },
                {
                    value: "notReviewedLast180D",
                    text: this.$t("reviews.list.stateFilterNotReviewedLast180D"),
                },
                {
                    value: "notReviewedLast360D",
                    text: this.$t("reviews.list.stateFilterNotReviewedLast360D"),
                },
                {
                    value: "missingSignature",
                    text: this.$t("reviews.list.stateFilterMissingSignature"),
                },
            ];
        },
        canLoadMoreReviews() {
            return this.participantProgress.length && this.offset < this.participantProgress.length;
        },
    },
    methods: {
        applyUserFilters(filter) {
            this.userFilter = { include: filter };
            this.offset = 0;
            this.getParticipantProgress(true);
        },
        applyStateFilters(e) {
            this.offset = 0;
            this.stateFilter = e.target.value;
            this.getParticipantProgress(true);
        },
        getParticipantProgress(reset) {
            this.$store.dispatch({
                type: "reviews/assessments/getParticipantProgress",
                payload: {
                    userFilter: this.userFilter,
                    stateFilter: this.stateFilter,
                    offset: this.offset,
                    reset,
                },
            });
        },
        getMoreReviewsByEmployee() {
            if (this.canLoadMoreReviews) {
                this.offset = this.participantProgress.length;
                this.getParticipantProgress();
            }
        },
    },
};
</script>
